import type { SVGProps } from 'react'
const LineSeat = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M4.75 22h14.5A2.75 2.75 0 0 0 22 19.25V14c0-1.208-.86-2.218-2-2.45v-4.8A4.75 4.75 0 0 0 15.25 2h-6.5A4.75 4.75 0 0 0 4 6.75v4.8c-1.14.232-2 1.242-2 2.45v5.25A2.75 2.75 0 0 0 4.75 22m4-18.5A3.25 3.25 0 0 0 5.5 6.75v4.959A2.5 2.5 0 0 1 7 14v1.675A18.7 18.7 0 0 1 12 15c1.73 0 3.407.235 5 .675V14c0-1.024.618-1.905 1.5-2.291V6.75a3.25 3.25 0 0 0-3.25-3.25zM17 17.237a17.2 17.2 0 0 0-5-.737c-1.74 0-3.419.258-5 .737V20.5h10zM4.5 13c-.55 0-1 .45-1 1v5.25c0 .69.56 1.25 1.25 1.25h.75V14c0-.55-.45-1-1-1m14 1c0-.55.45-1 1-1s1 .45 1 1v5.25c0 .69-.56 1.25-1.25 1.25h-.75z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineSeat }
